var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"spinStyle",style:(_vm.spinHeight ? { height: _vm.spinHeight + 'px' } : '')},[(_vm.loading)?_c('a-spin',{attrs:{"tip":"Loading..."}}):_vm._e()],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }